var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "m1.088 4.21 4.187 5.271c.239.255.418.455.725.455s.474-.17.725-.455l4.187-5.27a.83.83 0 0 0-.033-.806.82.82 0 0 0-.691-.405H1.812a.82.82 0 0 0-.69.406.83.83 0 0 0-.034.805"
})));
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "ArrowRight.c1e382a4.svg";